export const deliveryConditions = {
  dogs: {
    usd: {
      title: "DELIVERY CONDITIONS - UNITED STATES AND CANADA",
      conditions: [
        "1. 3-month medical insurance (covered by the company)",
        "Veterinary coverage backed by one of the best insurance companies in the country.",
        "",
        "2. Lifetime health and protection guarantee",
        "Permanent coverage for congenital and hereditary conditions, fully backed.",
        "",
        "3. Up-to-date vaccination card",
        "Includes all vaccines corresponding to their age, applied and registered.",
        "",
        "4. Pure breed certificate",
        "Official document guaranteeing the total purity of the puppy.",
        "",
        "5. Veterinary health certificate",
        "Professional endorsement certifying the excellent general condition of the puppy.",
        "",
        "6. Identification microchip",
        "Installed and registered for security, travel, or location purposes.",
        "",
        "7. First antiparasitic treatment (Blu-ray)",
        "Deworming applied according to puppy's weight and age.",
        "",
        "8. Free accessories package",
        "Includes: Food bowl, Water bowl, Adjustable harness, Leash, Collar, Toy",
        "",
        "9. Free medical consultation for 6 months",
        "Virtual veterinary care at no cost during the first six months.",
        "",
        "10. Free delivery to all United States and Canada",
        "Door-to-door shipping fully included, fast and secure.",
        "",
        "11. Complete medical record",
        "Includes: Heart examination, Hearing check, Skin and coat evaluation, Bone system analysis, Blood test",
        "",
        "12. First professional grooming included",
        "The puppy is delivered perfectly bathed, groomed, and perfumed, in optimal conditions."
      ]
    },
    pab: {
      title: "CONDICIONES DE ENTREGA – CACHORROS EN PANAMÁ",
      conditions: [
        "1. Cuarentena preventiva",
        "Todos nuestros cachorros pasan por una cuarentena supervisada para asegurar su bienestar y descartar cualquier enfermedad viral. Tu nuevo compañero está completamente sano y listo para unirse a tu familia.",
        "",
        "2. Revisión veterinaria completa",
        "Nos aseguramos de que cada cachorro reciba un chequeo profesional, que incluye: Audición, Visión, Corazón, Piel y pelaje, Sistema óseo",
        "",
        "3. Certificado de pureza de base",
        "Te entregamos un certificado que garantiza que el cachorro es de pura raza, respaldado por nuestra empresa, para que tengas la total seguridad de que estás adquiriendo un cachorro auténtico.",
        "",
        "4. Certificado de salud",
        "Cada cachorro recibe un certificado emitido por un veterinario profesional que asegura que se encuentra en perfectas condiciones de salud. ¡Solo lo mejor para tu nuevo amigo!",
        "",
        "5. Tarjeta de vacunación al día",
        "Tu cachorro contará con todas las vacunas necesarias de acuerdo a su edad, dándole la protección que necesita desde el primer día.",
        "",
        "6. Paquete de accesorios de regalo",
        "Cada cachorro viene con un kit de bienvenida que incluye: Taza para comida, Taza para agua, Apoya plato, Juguete, Pechera ajustable, Correa",
        "",
        "7. Consultas médicas virtuales GRATIS por 3 meses",
        "Ofrecemos asistencia veterinaria sin costo adicional, a través de consultas virtuales, durante los primeros 90 días para que siempre tengas el apoyo necesario.",
        "",
        "8. Servicio de entrega a domicilio disponible",
        "Realizamos entregas a domicilio una vez a la semana. El servicio de entrega tiene un costo adicional, pero te aseguramos que tu cachorro llegará de manera segura y profesional hasta la puerta de tu hogar."
      ]
    },
    nio: {
      title: "CONDICIONES DE ENTREGA – CACHORROS EN EL SALVADOR",
      conditions: [
        "1. Cuarentena preventiva",
        "Todos nuestros cachorros pasan por una cuarentena supervisada para asegurar su bienestar y descartar cualquier enfermedad viral. Tu nuevo compañero está completamente sano y listo para unirse a tu familia.",
        "",
        "2. Revisión veterinaria completa",
        "Nos aseguramos de que cada cachorro reciba un chequeo profesional, que incluye: Audición, Visión, Corazón, Piel y pelaje, Sistema óseo",
        "",
        "3. Certificado de pureza de base",
        "Te entregamos un certificado que garantiza que el cachorro es de pura raza, respaldado por nuestra empresa, para que tengas la total seguridad de que estás adquiriendo un cachorro auténtico.",
        "",
        "4. Certificado de salud",
        "Cada cachorro recibe un certificado emitido por un veterinario profesional que asegura que se encuentra en perfectas condiciones de salud. ¡Solo lo mejor para tu nuevo amigo!",
        "",
        "5. Tarjeta de vacunación al día",
        "Tu cachorro contará con todas las vacunas necesarias de acuerdo a su edad, dándole la protección que necesita desde el primer día.",
        "",
        "6. Paquete de accesorios de regalo",
        "Cada cachorro viene con un kit de bienvenida que incluye: Taza para comida, Taza para agua, Apoya plato, Juguete, Pechera ajustable, Correa",
        "",
        "7. Consultas médicas virtuales GRATIS por 3 meses",
        "Ofrecemos asistencia veterinaria sin costo adicional, a través de consultas virtuales, durante los primeros 90 días para que siempre tengas el apoyo necesario.",
        "",
        "8. Servicio de entrega a domicilio disponible",
        "Realizamos entregas a domicilio una vez a la semana. El servicio de entrega tiene un costo adicional, pero te aseguramos que tu cachorro llegará de manera segura y profesional hasta la puerta de tu hogar."
      ]
    },
    crc: {
      title: "CONDICIONES DE ENTREGA – CACHORROS EN COSTA RICA",
      conditions: [
        "1. Cuarentena preventiva",
        "Todos nuestros cachorros pasan por una cuarentena supervisada para asegurar su bienestar y descartar cualquier enfermedad viral. Tu nuevo compañero está completamente sano y listo para unirse a tu familia.",
        "",
        "2. Revisión veterinaria completa",
        "Nos aseguramos de que cada cachorro reciba un chequeo profesional, que incluye: Audición, Visión, Corazón, Piel y pelaje, Sistema óseo",
        "",
        "3. Certificado de pureza de base",
        "Te entregamos un certificado que garantiza que el cachorro es de pura raza, respaldado por nuestra empresa, para que tengas la total seguridad de que estás adquiriendo un cachorro auténtico.",
        "",
        "4. Certificado de salud",
        "Cada cachorro recibe un certificado emitido por un veterinario profesional que asegura que se encuentra en perfectas condiciones de salud. ¡Solo lo mejor para tu nuevo amigo!",
        "",
        "5. Tarjeta de vacunación al día",
        "Tu cachorro contará con todas las vacunas necesarias de acuerdo a su edad, dándole la protección que necesita desde el primer día.",
        "",
        "6. Paquete de accesorios de regalo",
        "Cada cachorro viene con un kit de bienvenida que incluye: Taza para comida, Taza para agua, Apoya plato, Juguete, Pechera ajustable, Correa (los accesorios pueden variar según disponibilidad)",
        "",
        "7. Consultas médicas virtuales GRATIS por 3 meses",
        "Ofrecemos asistencia veterinaria sin costo adicional, a través de consultas virtuales, durante los primeros 90 días para que siempre tengas el apoyo necesario.",
        "",
        "8. Tienda física en Costa Rica",
        "Contamos con una tienda física donde puedes visitarnos, conocer a los cachorros y adquirir productos de calidad con total confianza.",
        "",
        "9. Servicio de entrega a domicilio disponible",
        "Llevamos a tu cachorro de manera segura y profesional hasta la puerta de tu hogar. Este servicio está disponible en todo el país y no tiene costo adicional."
      ]
    }
  },
  cats: {
    usd: {
      title: "DELIVERY CONDITIONS - UNITED STATES AND CANADA",
      conditions: [
        "1. 3-month medical insurance (covered by the company)",
        "Veterinary coverage backed by one of the best insurance companies in the country.",
        "",
        "2. Lifetime health and protection guarantee",
        "Permanent coverage for congenital and hereditary conditions, fully backed.",
        "",
        "3. Up-to-date vaccination card",
        "Includes all vaccines corresponding to their age, applied and registered.",
        "",
        "4. Pure breed certificate",
        "Official document guaranteeing the total purity of the puppy.",
        "",
        "5. Veterinary health certificate",
        "Professional endorsement certifying the excellent general condition of the puppy.",
        "",
        "6. Identification microchip",
        "Installed and registered for security, travel, or location purposes.",
        "",
        "7. First antiparasitic treatment (Blu-ray)",
        "Deworming applied according to puppy's weight and age.",
        "",
        "8. Free accessories package",
        "Includes: Food bowl, Water bowl, Adjustable harness, Leash, Collar, Toy",
        "",
        "9. Free medical consultation for 6 months",
        "Virtual veterinary care at no cost during the first six months.",
        "",
        "10. Free delivery to all United States and Canada",
        "Door-to-door shipping fully included, fast and secure.",
        "",
        "11. Complete medical record",
        "Includes: Heart examination, Hearing check, Skin and coat evaluation, Bone system analysis, Blood test",
        "",
        "12. First professional grooming included",
        "The puppy is delivered perfectly bathed, groomed, and perfumed, in optimal conditions."
      ]
    },
    pab: {
      title: "CONDICIONES DE ENTREGA – CACHORROS EN PANAMÁ",
      conditions: [
        "1. Cuarentena preventiva",
        "Todos nuestros cachorros pasan por una cuarentena supervisada para asegurar su bienestar y descartar cualquier enfermedad viral. Tu nuevo compañero está completamente sano y listo para unirse a tu familia.",
        "",
        "2. Revisión veterinaria completa",
        "Nos aseguramos de que cada cachorro reciba un chequeo profesional, que incluye: Audición, Visión, Corazón, Piel y pelaje, Sistema óseo",
        "",
        "3. Certificado de pureza de base",
        "Te entregamos un certificado que garantiza que el cachorro es de pura raza, respaldado por nuestra empresa, para que tengas la total seguridad de que estás adquiriendo un cachorro auténtico.",
        "",
        "4. Certificado de salud",
        "Cada cachorro recibe un certificado emitido por un veterinario profesional que asegura que se encuentra en perfectas condiciones de salud. ¡Solo lo mejor para tu nuevo amigo!",
        "",
        "5. Tarjeta de vacunación al día",
        "Tu cachorro contará con todas las vacunas necesarias de acuerdo a su edad, dándole la protección que necesita desde el primer día.",
        "",
        "6. Paquete de accesorios de regalo",
        "Cada cachorro viene con un kit de bienvenida que incluye: Taza para comida, Taza para agua, Apoya plato, Juguete, Pechera ajustable, Correa",
        "",
        "7. Consultas médicas virtuales GRATIS por 3 meses",
        "Ofrecemos asistencia veterinaria sin costo adicional, a través de consultas virtuales, durante los primeros 90 días para que siempre tengas el apoyo necesario.",
        "",
        "8. Servicio de entrega a domicilio disponible",
        "Realizamos entregas a domicilio una vez a la semana. El servicio de entrega tiene un costo adicional, pero te aseguramos que tu cachorro llegará de manera segura y profesional hasta la puerta de tu hogar."
      ]
    },
    nio: {
      title: "CONDICIONES DE ENTREGA – CACHORROS EN EL SALVADOR",
      conditions: [
        "1. Cuarentena preventiva",
        "Todos nuestros cachorros pasan por una cuarentena supervisada para asegurar su bienestar y descartar cualquier enfermedad viral. Tu nuevo compañero está completamente sano y listo para unirse a tu familia.",
        "",
        "2. Revisión veterinaria completa",
        "Nos aseguramos de que cada cachorro reciba un chequeo profesional, que incluye: Audición, Visión, Corazón, Piel y pelaje, Sistema óseo",
        "",
        "3. Certificado de pureza de base",
        "Te entregamos un certificado que garantiza que el cachorro es de pura raza, respaldado por nuestra empresa, para que tengas la total seguridad de que estás adquiriendo un cachorro auténtico.",
        "",
        "4. Certificado de salud",
        "Cada cachorro recibe un certificado emitido por un veterinario profesional que asegura que se encuentra en perfectas condiciones de salud. ¡Solo lo mejor para tu nuevo amigo!",
        "",
        "5. Tarjeta de vacunación al día",
        "Tu cachorro contará con todas las vacunas necesarias de acuerdo a su edad, dándole la protección que necesita desde el primer día.",
        "",
        "6. Paquete de accesorios de regalo",
        "Cada cachorro viene con un kit de bienvenida que incluye: Taza para comida, Taza para agua, Apoya plato, Juguete, Pechera ajustable, Correa",
        "",
        "7. Consultas médicas virtuales GRATIS por 3 meses",
        "Ofrecemos asistencia veterinaria sin costo adicional, a través de consultas virtuales, durante los primeros 90 días para que siempre tengas el apoyo necesario.",
        "",
        "8. Servicio de entrega a domicilio disponible",
        "Realizamos entregas a domicilio una vez a la semana. El servicio de entrega tiene un costo adicional, pero te aseguramos que tu cachorro llegará de manera segura y profesional hasta la puerta de tu hogar."
      ]
    },
    crc: {
      title: "CONDICIONES DE ENTREGA – CACHORROS EN COSTA RICA",
      conditions: [
        "1. Cuarentena preventiva",
        "Todos nuestros cachorros pasan por una cuarentena supervisada para asegurar su bienestar y descartar cualquier enfermedad viral. Tu nuevo compañero está completamente sano y listo para unirse a tu familia.",
        "",
        "2. Revisión veterinaria completa",
        "Nos aseguramos de que cada cachorro reciba un chequeo profesional, que incluye: Audición, Visión, Corazón, Piel y pelaje, Sistema óseo",
        "",
        "3. Certificado de pureza de base",
        "Te entregamos un certificado que garantiza que el cachorro es de pura raza, respaldado por nuestra empresa, para que tengas la total seguridad de que estás adquiriendo un cachorro auténtico.",
        "",
        "4. Certificado de salud",
        "Cada cachorro recibe un certificado emitido por un veterinario profesional que asegura que se encuentra en perfectas condiciones de salud. ¡Solo lo mejor para tu nuevo amigo!",
        "",
        "5. Tarjeta de vacunación al día",
        "Tu cachorro contará con todas las vacunas necesarias de acuerdo a su edad, dándole la protección que necesita desde el primer día.",
        "",
        "6. Paquete de accesorios de regalo",
        "Cada cachorro viene con un kit de bienvenida que incluye: Taza para comida, Taza para agua, Apoya plato, Juguete, Pechera ajustable, Correa (los accesorios pueden variar según disponibilidad)",
        "",
        "7. Consultas médicas virtuales GRATIS por 3 meses",
        "Ofrecemos asistencia veterinaria sin costo adicional, a través de consultas virtuales, durante los primeros 90 días para que siempre tengas el apoyo necesario.",
        "",
        "8. Tienda física en Costa Rica",
        "Contamos con una tienda física donde puedes visitarnos, conocer a los cachorros y adquirir productos de calidad con total confianza.",
        "",
        "9. Servicio de entrega a domicilio disponible",
        "Llevamos a tu cachorro de manera segura y profesional hasta la puerta de tu hogar. Este servicio está disponible en todo el país y no tiene costo adicional."
      ]
    }
  }
}; 